import java from "../assets/images/java_logo.png";
import mit from "../assets/images/mit_logo.png";
import webdev from "../assets/images/webdev_logo.png";
import scratch from "../assets/images/scratch_logo.png";
import python from "../assets/images/python_logo.png";
import math_icon from "../assets/images/math_icon.svg";
import app_dev_logo from "../assets/images/app_dev_logo.svg";
import robotics_logo from "../assets/images/robotics_logo.svg";
import science_logo from "../assets/images/science_logo.svg";
import default_icon from "../assets/images/default_icon.svg";

export const getDefaultImg = (courseName) => {
  if (!courseName) {
    return default_icon;
  }
  let lowerCourseName = courseName?.toLowerCase();
  if (lowerCourseName.includes("scratch")) {
    return scratch;
  } else if (lowerCourseName.includes("java")) {
    return java;
  } else if (lowerCourseName.includes("web")) {
    return webdev;
  } else if (
    lowerCourseName.includes("learning") ||
    lowerCourseName.includes("game") ||
    lowerCourseName.includes("python")
  ) {
    return python;
  } else if (lowerCourseName.includes("mit")) {
    return mit;
  } else if (
    lowerCourseName.includes("math") ||
    lowerCourseName.includes("algebra") ||
    lowerCourseName.includes("geometry")
  ) {
    return math_icon;
  } else if (lowerCourseName.includes("science")) {
    return science_logo;
  } else if (lowerCourseName.includes("robotics")) {
    return robotics_logo;
  } else if (
    lowerCourseName.includes("android") ||
    lowerCourseName.includes("appdev")
  ) {
    return app_dev_logo;
  } else {
    return default_icon;
  }
};
